import type { KanbanLog } from '@entities/kanban-comment'
import type { Pagination } from '@shared/config'

import { useCommonStore } from '@shared/model'
import { useAdminRoutes } from '@shared/lib/routes'

import { useTutorKanbanStore } from '../model/store'

interface LogsApiOptions {
  tutorId: string | number
  onStart?: () => void
  onSuccess?: (data: KanbanLog[]) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

interface LogsApiResponse {
  logs: KanbanLog[]
  meta: Pagination
}

export const useLogsApi = async (options: LogsApiOptions): Promise<KanbanLog[]> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.tutor-kanban.logs', { tutor_id: options.tutorId })

  const tutorKanbanStore = useTutorKanbanStore()
  const commonStore = useCommonStore()

  options.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const response: LogsApiResponse = data.data

    tutorKanbanStore.setLogs(response.logs)
    tutorKanbanStore.setLogsPagination(response.meta)
    commonStore.setLoading(false)

    options.onSuccess?.(response.logs)

    return response.logs
  } catch (err: unknown) {
    console.error(err)
    commonStore.setLoading(false)
    options.onError?.(err)

    return []
  } finally {
    options.onFinish?.()
  }
}
